var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaixacheckada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 48,
    viewBox: "0 0 446 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_419)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 445,
    height: 47,
    rx: 5.5,
    stroke: "#1690C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.01 31.61L428.29 20.33L426.05 18.09L417.01 27.13L412.45 22.57L410.21 24.81L417.01 31.61ZM419.25 40.25C417.037 40.25 414.957 39.8297 413.01 38.9892C411.063 38.1487 409.37 37.0089 407.93 35.57C406.49 34.13 405.35 32.4367 404.511 30.49C403.671 28.5433 403.251 26.4633 403.25 24.25C403.25 22.0367 403.67 19.9567 404.511 18.01C405.351 16.0633 406.491 14.37 407.93 12.93C409.37 11.49 411.063 10.3503 413.01 9.5108C414.957 8.67133 417.037 8.25107 419.25 8.25C421.463 8.25 423.543 8.67027 425.49 9.5108C427.437 10.3513 429.13 11.4911 430.57 12.93C432.01 14.37 433.15 16.0633 433.991 18.01C434.831 19.9567 435.251 22.0367 435.25 24.25C435.25 26.4633 434.83 28.5433 433.989 30.49C433.149 32.4367 432.009 34.13 430.57 35.57C429.13 37.01 427.437 38.1503 425.49 38.9908C423.543 39.8313 421.463 40.2511 419.25 40.25ZM419.25 37.05C422.823 37.05 425.85 35.81 428.33 33.33C430.81 30.85 432.05 27.8233 432.05 24.25C432.05 20.6767 430.81 17.65 428.33 15.17C425.85 12.69 422.823 11.45 419.25 11.45C415.677 11.45 412.65 12.69 410.17 15.17C407.69 17.65 406.45 20.6767 406.45 24.25C406.45 27.8233 407.69 30.85 410.17 33.33C412.65 35.81 415.677 37.05 419.25 37.05Z",
    fill: "#1690C3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 443,
    height: 45,
    rx: 4.5,
    stroke: "#1690C3",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 446,
    height: 48,
    rx: 6,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaixacheckada);
export default __webpack_public_path__ + "static/media/caixacheckada.461b38e81fe001e6faff81f005d0192c.svg";
export { ForwardRef as ReactComponent };